import { useElementUpdate } from '@tunasong/editor'
import type { TunaPluginContentProps } from '@tunasong/plugin-lib'
import type { Poll } from '@tunasong/schemas'
import { isDatePoll, isGroupedPoll, isManyOfManyPoll, isOneOfManyPoll, isPersisted } from '@tunasong/schemas'
import { useCurrentUser } from '@tunasong/redux'
import type { FC } from 'react'
import invariant from 'tiny-invariant'
import { DatePollVote } from '../date-poll-vote.js'
import { GroupedPollVote } from '../grouped/vote.js'
import { ManyOfManyPollVote } from '../many-of-many/vote.js'
import { OneOfManyPollVote } from '../one-of-many/vote.js'
export const DefaultContentView: FC<TunaPluginContentProps<Poll>> = props => {
  const { element: poll } = props

  const { userId } = useCurrentUser()

  const handleChange = useElementUpdate(poll)

  invariant(userId, 'User ID is required')

  /** @todo this should not be required, but currently we need ACLs as part of the poll for it to have children */
  if (!isPersisted(poll)) {
    return <>Poll is not persisted</>
  }

  /** A rehearsal poll is a many-of-many poll with dated slots, so this branch comes first. */
  if (isDatePoll(poll)) {
    return <DatePollVote poll={poll} userId={userId} />
  }
  /** A grouped poll is many-of-many too, so it is routed before the plain branch. */
  if (isGroupedPoll(poll)) {
    return <GroupedPollVote poll={poll} userId={userId} onChange={handleChange} />
  }
  if (isManyOfManyPoll(poll)) {
    return <ManyOfManyPollVote poll={poll} userId={userId} onChange={handleChange} />
  }
  if (isOneOfManyPoll(poll)) {
    return <OneOfManyPollVote poll={poll} userId={userId} onChange={handleChange} />
  }
}

export default DefaultContentView
